export default "__VITE_ASSET__CL6kBlGs__"